import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";

// Scroll-reveal wrapper. Defaults to a subtle fade-up.
export const Reveal = ({ children, variants = fadeUp, className = "", as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      variants={variants}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
